import { a as makeExports } from './chunk-e2d64c7a.js';
import 'string-hash';
import 'asap';
import 'inline-style-prefixer/lib/createPrefixer';
import 'inline-style-prefixer/lib/plugins/backgroundClip';
import 'inline-style-prefixer/lib/plugins/calc';
import 'inline-style-prefixer/lib/plugins/crossFade';
import 'inline-style-prefixer/lib/plugins/cursor';
import 'inline-style-prefixer/lib/plugins/filter';
import 'inline-style-prefixer/lib/plugins/flex';
import 'inline-style-prefixer/lib/plugins/flexboxIE';
import 'inline-style-prefixer/lib/plugins/flexboxOld';
import 'inline-style-prefixer/lib/plugins/gradient';
import 'inline-style-prefixer/lib/plugins/imageSet';
import 'inline-style-prefixer/lib/plugins/logical';
import 'inline-style-prefixer/lib/plugins/position';
import 'inline-style-prefixer/lib/plugins/sizing';
import 'inline-style-prefixer/lib/plugins/transition';

var useImportant = true; // Add !important to all style definitions

var Aphrodite = makeExports(useImportant);
var StyleSheet = Aphrodite.StyleSheet,
    StyleSheetServer = Aphrodite.StyleSheetServer,
    StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
    css = Aphrodite.css,
    minify = Aphrodite.minify,
    flushToStyleTag = Aphrodite.flushToStyleTag,
    injectAndGetClassName = Aphrodite.injectAndGetClassName,
    defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers;

export { StyleSheet, StyleSheetServer, StyleSheetTestUtils, css, minify, flushToStyleTag, injectAndGetClassName, defaultSelectorHandlers };



//////////////////
// WEBPACK FOOTER
// ./node_modules/aphrodite/es/index.js
// module id = 1
// module chunks = 0